const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/analyze/dashboards.$.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
// This route ends with the splat/catch-all operator to catch any sub-path added by Metabase
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/analyze/dashboards/$")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Dashboards",
      description: "Page title for the metabase dashboards page"
    })
  }
});